module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"fieldName":"Field Name","size":"Size","plants":"Plants"},"es":{"fieldName":"Nombre del campo","size":"Tamaño","plants":"Total Plantas"},"sw":{"fieldName":"Jina la Shamba","size":"Ukubwa","plants":"Mimea"}}')
  delete Component.options._Ctor
}
